module.exports = __webpack_public_path__ + "img/joe_pose1.f09e3fca.png";